import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getAccountIntegrationsAction,
  getIntegrationAction,
  getIntegrationsAction,
  State,
} from '../store';
import { IntegrationID } from '../store/interfaces';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  constructor(private readonly store: Store<State>) {}

  getIntegrations() {
    this.store.dispatch(getIntegrationsAction());
  }

  getIntegration(id: IntegrationID) {
    this.store.dispatch(getIntegrationAction({ id }));
  }

  getAccountIntegrations(accountId: string) {
    this.store.dispatch(getAccountIntegrationsAction({ accountId }));
  }
}
